function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUsec(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M48 4.901L3.166 21.526l.979 3.54c1.499 5.425 2.243 10.159 2.963 14.738C9.321 53.887 11.07 65.01 32.065 79.462c5.72 3.937 11.051 9.299 12.802 11.061l3.106 3.106 2.828-2.774c1.935-1.897 7.15-6.795 13.789-11.294 18.745-12.698 26.991-53.066 27.333-54.778l.668-3.347L48 4.901zm30.015 39.383c-5.223 14.345-11.417 24.254-17.913 28.654-4.973 3.37-9.206 6.945-12.032 9.506-2.723-2.624-6.941-6.456-11.469-9.572-18.162-12.502-19.526-21.178-21.59-34.31-.57-3.626-1.201-7.636-2.244-12.063L48 13.433l35.329 13.101c-.915 3.818-2.674 10.501-5.314 17.75z"
  }), React.createElement("path", {
    d: "M42.501 31.859v.768c0 .16-.392.342-.821.547l-.293-.544c-1.757-1.757-4.482-1.757-6.239 0s-1.695 4.607.062 6.364l.575.864c-.205.428-.357.641-.516 1.641H34.5a4.5 4.5 0 000 9h.768c.16 0 .342.572.547 1l-.544.383a4.405 4.405 0 000 6.284c1.757 1.757 4.607 1.717 6.364-.04l.043-.564c.428.205.821.368.821.527v.768a4.5 4.5 0 009 0v-.768c1-.16 1.392-.342 1.821-.547l.793.544c1.757 1.757 4.732 1.757 6.489 0s1.82-4.607.062-6.364l-.511-.222c.205-.428.419-1 .579-1h.768a4.5 4.5 0 000-9h-.768c-.16-1-.342-1.213-.547-1.641l.544-.704c1.757-1.757 1.757-4.687 0-6.444s-4.607-1.797-6.364-.04l-1.043.524c-.428-.205-.821-.408-1.821-.568v-.768a4.5 4.5 0 00-9 0zm6.708 7.622a6.007 6.007 0 014.669 7.087 6.007 6.007 0 01-7.087 4.669 6.007 6.007 0 01-4.669-7.087 6.007 6.007 0 017.087-4.669z"
  }));
}

SvgUsec.clsName = 'icon-www__usec';
SvgUsec.remarkName = 'unknown';
export default SvgUsec;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Usec.js
// module id = 2522
// module chunks = 17 18